import {PublicLayout} from './PublicLayout.tsx';
import {useUserAccount} from "../hooks/useUserAccount.ts";
import {
    useEffect,
    useState
} from "react";
import {PlatformLoader} from "@flexinet/ui-components";
import {UserLayout} from './UserLayout.tsx';

export const AppLayout = () => {
    const [wait, setWait] = useState(true);

    const {userAccount} = useUserAccount()

    useEffect(() => {
        setTimeout(() => {
            setWait(false);
        }, 2000);
    }, []);

    if (wait) {
        return <PlatformLoader message={'Checking status...Please, wait!'}/>;
    }

    return userAccount ? <UserLayout/> : <PublicLayout/>
};
